import { useMutation, useQueryClient } from '@tanstack/react-query'

import { AUTHENTICATED_USER_PROFILE_KEY } from '@sparkai/auth'

import { apiClient } from '../apiClient'
import { USER_PROFILE_KEY } from './useProfile'

type MineAvatarRequest = {
  mediaId: string | null
}

export function useCreateAvatar(onSuccess?: () => void, onError?: () => void) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (values: MineAvatarRequest) => {
      const { data } = await apiClient.patch('/int/v3/users/me/avatar', values)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [AUTHENTICATED_USER_PROFILE_KEY] })
      queryClient.invalidateQueries({ queryKey: [USER_PROFILE_KEY] })
      onSuccess?.()
    },
    onError: onError,
  })
}
